import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgProperty2FidelityLow = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#property-2-fidelity-low_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M56 35.281c0-3.696-.711-7.356-2.093-10.77a28.2 28.2 0 0 0-5.962-9.131 27.5 27.5 0 0 0-8.921-6.101A27 27 0 0 0 28.5 7.136c-3.611 0-7.187.728-10.524 2.143a27.5 27.5 0 0 0-8.921 6.1 28.2 28.2 0 0 0-5.962 9.132A28.7 28.7 0 0 0 1 35.28h55"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C3DCBF",
        d: "M40.652 44.586C27.19 44.586 24.045 53 14.442 53 6.608 53 1 49.765 1 40.96v-5.797H56c-.001 5.374-2.782 9.423-15.348 9.423"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CDDBE9",
        fillRule: "evenodd",
        d: "M22.28 5.243h24.017V35.67H22.28z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#50769A",
        d: "M22.28 5.243V35.67h-3.925V7.45z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#7A9EBF",
        d: "M25.502 29.44h-1.243v2.242H25.5zM25.502 21.414h-1.243v2.21H25.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M27.475 15.477h-5.193v4.16h5.193zM27.476 7.158h-5.192v4.16h5.192zM27.476 11.318v-4.16h4.451zM27.475 31.687h-5.193v3.966h5.193zM27.475 23.624h-5.193v4.16h5.193z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m33.595 35.67-6.151-3.983v3.967zM27.444 23.566l6.151 3.983v4.139l-6.151-3.984zM33.595 23.583l-6.151-3.984V15.46l6.151 3.984zM46.299 11.23H33.595L31 13.31l2.596 1.907H46.3zM46.299 19.463H33.595v4.073H46.3zM46.299 27.61H33.595v4.073H46.3z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A8C3DD",
        d: "M46.297 5.243H22.27v.705h24.027z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "m30.372 13.607-5.158 7.21-5.22-7.21z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        d: "m35.53 20.818-5.158-7.211H19.994l5.22 7.21H21.82l-8.428-10.26h17.707l8.114 10.26z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#50769A",
        d: "M21.819 20.818v19.116H7.999V16.19l5.392-5.634z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m30.372 13.607 5.157 7.21h3.683v19.117H21.819V20.818h3.395z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A8C3DD",
        d: "M35.353 32.972c0-2.924-3.352-2.994-3.352 0v6.962h3.352zM28.648 32.972c0-2.924-3.352-2.994-3.352 0v6.962h3.352z"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 1.504,
        cy: 1.423,
        fill: "#A8C3DD",
        rx: 1.504,
        ry: 1.423,
        transform: "matrix(-1 0 0 1 31.827 18.098)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M34.894 27.09h-2.69v-2.437h2.69zM28.19 27.09H25.5v-2.438h2.69z"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: 8.199,
        cy: 8.633,
        fill: "#89B081",
        rx: 8.199,
        ry: 8.633,
        transform: "matrix(0 -1 -1 0 18.268 42.879)"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `property-2-fidelity-low_svg__a-${id}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h56v56H0z"
    }))));
};
export default SvgProperty2FidelityLow;
